module.exports = __webpack_public_path__ + "img/03l_Store_651.69ab1712.jpg";